import React, { Fragment } from 'react';
import validator from 'validator';
import { Link } from 'react-router-dom';
import { Popup, EditableComponent, InputField } from 'arteia-js/components';
import { API } from 'arteia-js/services';
import { backgroundArtworks } from '../configs/backgroundArtworks.config';

var artwork =
  backgroundArtworks[Math.floor(Math.random() * backgroundArtworks.length)];
class ForgotPassword extends EditableComponent {
  state = {
    passwordFocused: false,
    email: '',
    loading: false,
    sent: false,
  };

  isDataCorrect = () => {
    const { email } = this.state;
    return validator.isEmail(email);
  };

  submit = () => {
    const { email } = this.state;
    this.setState({ loading: true });

    API.post('/forgot-password', {
      email,
    })
      .then(() => {
        this.setState({
          loading: false,
          sent: true,
        });
      })
      .catch((e) => {
        this.setState({
          loading: false,
          error: true,
          errorCode: e.status,
          errorMessage: this.ERROR_MESSAGES[e.status],
        });
      });
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter' && this.isDataCorrect()) {
      this.submit();
    }
  };

  goToLoginPage = () => {
    const { history } = this.props;
    return history.push('/login');
  };

  ERROR_MESSAGES = {
    404: 'Ooops',
    500: 'Something went wrong',
  };

  goBackToLoginPage = () => {
    const { history } = this.props;
    return history.goBack();
  };

  render() {
    const { email, sent } = this.state;
    return (
      <div
        className='forgot-password-wrapper'
        style={{ backgroundImage: `url(${artwork.asset})` }}
      >
        <div className='artwork-details'>
          <span className='artist-name'>{artwork.artistName}</span>
          <br />
          <span className='artwork-title'>
            {artwork.title}, {artwork.year}
          </span>
        </div>
        <span className='all-rights-reserved'>
          &copy; {new Date().getFullYear()} Arteïa - All rights reserved
        </span>
        <Popup size='form' className='forgot-password'>
          <div className='popup-content'>
            {sent && (
              <Fragment>
                <div className='email-sent'>
                  <i className='icon-icon_ok' />
                  <h1>Success</h1>
                  <p>We've sent an email with password reset instructions.</p>
                  <p className='muted'>
                    If the email doesn't show up soon, check your spam folder.
                    We sent it from service@arteia.co.
                  </p>
                  <br />
                </div>
                <div className='button-container'>
                  <button className='art-btn' onClick={this.goToLoginPage}>
                    Return to Login
                  </button>
                </div>
              </Fragment>
            )}
            {!sent && (
              <Fragment>
                <h1>Reset your password</h1>
                <p>
                  Please provide your email so we can send <br /> you
                  instructions on how to reset your <br /> password
                </p>
                <span className='input-label'>Email</span>
                <InputField
                  value={email}
                  onChange={this.onFieldChange('email')}
                  handleKeyPress={this.handleKeyPress}
                />
                <div className='button-container'>
                  <button
                    className='art-btn'
                    disabled={!this.isDataCorrect()}
                    onClick={this.submit}
                  >
                    Reset password
                    <img src='/ico-arrow-right.svg' />
                  </button>
                </div>
                <a
                  className='secondary-a'
                  onClick={() => this.goBackToLoginPage()}
                >
                  &lt; Back to Login page
                </a>
              </Fragment>
            )}
          </div>
        </Popup>
      </div>
    );
  }
}

ForgotPassword.propTypes = {};
ForgotPassword.defaultProps = {};

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/scenes/ForgotPassword/index.js